"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useDialogPreventParentScroll(isOpen) {
  react_1.useEffect(function () {
    var bodyEl = document.querySelector('body');

    if (bodyEl === null) {
      return;
    }

    if (isOpen) {
      bodyEl.style.overflow = 'hidden';
      return;
    }

    bodyEl.style.overflow = 'auto';
  }, [isOpen]);
  react_1.useEffect(function () {
    var bodyEl = document.querySelector('body');
    return function () {
      if (bodyEl !== null) {
        bodyEl.style.overflow = 'auto';
      }
    };
  }, []);
}

exports.default = useDialogPreventParentScroll;